import type { PlcManufacturerCodeLibrary } from "./types";

export const keyenceCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "keyence",
  manufacturer_name: "KEYENCE",
  codes: [
    {
      id: "keyence-kv8000-error-code-list",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: null,
      code: "CPU ERROR CODE",
      code_type: "CPU Diagnostic",
      title_ar: "KV-8000 CPU Error Code",
      description_ar: "دليل CPU Unit الرسمي للـKV Series يحتوي Error Code Lists؛ التشخيص الصحيح يكون بقراءة الكود الظاهر من KV STUDIO/CPU diagnostics ومطابقته بدليل نفس السلسلة.",
      symptoms: ["CPU يعرض Error", "KV STUDIO يبين error code"],
      causes: ["Hardware/communication/program condition حسب الكود الفعلي"],
      checks: [
        {
          step: 1,
          action: "سجل الكود كما يظهر بـKV STUDIO بدون تغييره.",
          expected: "الكود محدد ويمكن مطابقته بدليل KV-8000.",
          faulty: "ماكو كود مسجل أو تمت إعادة التشغيل قبل تسجيله.",
        }
      ],
      solutions: ["طابق الكود مع CPU Unit User's Manual الخاص بـKV-8000.", "عالج السبب المحدد قبل Reset."],
      severity: "عالية",
      source_title: "KEYENCE KV Series User's Manual portal",
      source_section: "CPU Unit manuals include error code lists",
      keywords: ["KEYENCE", "KV-8000", "error code", "KV STUDIO"],
    },
    {
      id: "keyence-kvx-error-code-list",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: null,
      code: "CPU ERROR CODE",
      code_type: "CPU Diagnostic",
      title_ar: "KV-X CPU Error Code",
      description_ar: "دليل KV-X الرسمي يذكر أن User's Manual يحتوي Error Code Lists للـCPU والوحدات.",
      symptoms: ["KV-X يبين Error", "التشخيص موجود بـKV STUDIO"],
      causes: ["السبب يعتمد على الكود والوحدة"],
      checks: [
        {
          step: 1,
          action: "اقرأ الكود والوحدة المتأثرة من KV STUDIO.",
          expected: "الكود محدد بوحدة ومصدر واضح.",
          faulty: "التشخيص غير مسجل.",
        }
      ],
      solutions: ["استخدم Error Code List الخاص بالوحدة نفسها.", "لا تطبق كود KV-8000 على KV-X إذا الدليل يفرق بينهن."],
      severity: "عالية",
      source_title: "KEYENCE KV-X Series Manuals",
      source_section: "User's Manual includes error code lists",
      keywords: ["KEYENCE", "KV-X", "error code"],
    },
    {
      id: "keyence-kv8000-mor",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-8000",
      model: null,
      code: "MACHINE OPERATION RECORDER",
      code_type: "Troubleshooting Diagnostic",
      title_ar: "Machine Operation Recorder fault investigation",
      description_ar: "KV-8000 يسجل بيانات الأجهزة والكاميرات والأحداث قبل وبعد التوقف حتى يحدد سبب المشكلة.",
      symptoms: ["عطل متقطع صعب يتكرر قدام الفني", "تحتاج تعرف شنو صار قبل shutdown"],
      causes: ["سبب العملية أو sequence يحتاج تحليل زمني"],
      checks: [
        {
          step: 1,
          action: "افتح Machine Operation Recorder وشغل Playback حول وقت العطل.",
          expected: "تظهر الأحداث والمتغيرات مرتبطة زمنياً.",
          faulty: "ماكو recording للوقت المطلوب.",
        }
      ],
      solutions: ["استخدم Analysis لتحديد الأجهزة والـladder المرتبط.", "احفظ التسجيل قبل تغييرات البرنامج."],
      severity: "متوسطة",
      source_title: "KEYENCE KV-8000 product documentation",
      source_section: "Machine Operation Recorder: recording/playback/analysis",
      keywords: ["KEYENCE", "KV-8000", "MOR", "troubleshooting"],
    },
    {
      id: "keyence-kvx-mor",
      manufacturer_id: "keyence",
      series_id: "keyence-kv-x",
      model: null,
      code: "MACHINE OPERATION RECORDER",
      code_type: "Troubleshooting Diagnostic",
      title_ar: "KV-X Operation Recorder",
      description_ar: "KV-X يسجل variables/devices/cameras/events قبل وبعد العطل للمساعدة بالتشخيص.",
      symptoms: ["shutdown أو fault متقطع", "تحتاج تحليل sequence"],
      causes: ["العطل يحتاج correlate بين program وI/O/events"],
      checks: [
        {
          step: 1,
          action: "افتح recorder من أدوات KV Series واعرض الفترة قبل/بعد العطل.",
          expected: "تظهر كل البيانات المطلوبة.",
          faulty: "التسجيل مو مفعل أو الفترة مفقودة.",
        }
      ],
      solutions: ["فعل recorder حسب الدليل وخزن الحالة.", "حلل شجرة الأجهزة المرتبطة بالمشكلة."],
      severity: "متوسطة",
      source_title: "KEYENCE KV-X product documentation",
      source_section: "Operation recorder function",
      keywords: ["KEYENCE", "KV-X", "operation recorder"],
    },
  ],
};
